<template>
<b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
          <b-row class="border">
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Leads Motorwow</h4>
                  <b-btn-group>
                    <b-btn @click.stop="descargar_csv">Descargar Lista</b-btn>
                    <b-btn variant="danger" @click.stop="descargar_tiktok_catalog">Catálogo TikTok</b-btn>
                  </b-btn-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link :to="{ name: 'BrandListClient' }">Clientes por marcas</b-link> &raquo; Leads Motorwow:
                </b-col>
              </b-row>
              <b-row>
                <b-col>Mostrando <strong>{{ leads.length }}</strong> leads de la campaña Motorwow:</b-col>
              </b-row>
              <div class="mt-2"></div>
              <b-table striped hover :items="leads" :fields="fields" responsive>
                <template slot="cell(createdAt)" slot-scope="row">
                  {{ formatDate(row.item.createdAt) }}
                </template>
                <template slot="cell(middleware_status)" slot-scope="row">
                  <b-badge :variant="row.item.middleware_status === 'sent' ? 'success' : row.item.middleware_status === 'failed' ? 'danger' : 'warning'">
                    {{ row.item.middleware_status || 'pending' }}
                  </b-badge>
                </template>
                <template slot="cell(salesforce_status)" slot-scope="row">
                  <b-badge :variant="row.item.salesforce_status === 'sent' ? 'success' : row.item.salesforce_status === 'failed' ? 'danger' : 'warning'">
                    {{ row.item.salesforce_status || 'pending' }}
                  </b-badge>
                </template>
                <template slot="cell(actions)" slot-scope="row">
                  <b-btn size="sm" @click.stop="details(row.item)">Ver detalle</b-btn>
                </template>
              </b-table>
              <ul v-if="errors && errors.length">
                <li v-for="(error, index) in errors" :key="index">
                  <b-alert show variant="danger">{{error.message || error}}</b-alert>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-col>
    </b-row>

    <!-- Modal detalle -->
    <b-modal v-model="showModal" title="Detalle del Lead" size="lg" ok-only ok-variant="danger">
      <b-table v-if="selectedLead" :items="selectedLead" :fields="detailFields" responsive striped>
        <template slot="cell(key)" slot-scope="row">
          <strong>{{ row.item.key }}</strong>
        </template>
      </b-table>
    </b-modal>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import Header from './Header'

function convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
}

function exportCSVFile(headers, items, fileTitle) {
    if (headers) { items.unshift(headers); }
    var jsonObject = JSON.stringify(items);
    var csv = "\ufeff"+convertToCSV(jsonObject);
    var exportedFilenmae = fileTitle + '.csv' || 'export.csv';
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

var headersCSV = {
  first_name: 'Nombre',
  last_name: 'Apellidos',
  email: 'Correo',
  fone1_w2l: 'Teléfono',
  tipo_documento: 'Tipo Doc.',
  rut_w2l: 'N° Documento',
  brand_w2l: 'Marca',
  model_w2l: 'Modelo',
  version_w2l: 'Versión',
  sap_w2l: 'Código SAP',
  store: 'Concesionario',
  department: 'Departamento',
  campaign_tag: 'Campaña',
  utm_source: 'UTM Source',
  utm_medium: 'UTM Medium',
  utm_campaign: 'UTM Campaign',
  utm_content: 'UTM Content',
  turno: 'Turno',
  salesforce_status: 'Estado Salesforce',
  middleware_status: 'Estado Middleware',
  middleware_response: 'Respuesta Middleware',
  url1_w2l: 'URL Origen',
  createdAt: 'Fecha'
};

export default {
  components: { Header },
  name: "LandingMotorwowLeads",
  data() {
    return {
      fields: [
        { key: 'first_name', label: 'Nombre', sortable: true, class: 'text-left' },
        { key: 'last_name', label: 'Apellidos', sortable: true, class: 'text-center' },
        { key: 'email', label: 'Email', class: 'text-center' },
        { key: 'brand_w2l', label: 'Marca', sortable: true, class: 'text-center' },
        { key: 'model_w2l', label: 'Modelo', sortable: true, class: 'text-center' },
        { key: 'store', label: 'Tienda', sortable: true, class: 'text-center' },
        { key: 'utm_content', label: 'UTM Content', class: 'text-center' },
        { key: 'turno', label: 'Turno', class: 'text-center' },
        { key: 'salesforce_status', label: 'SalesForce', class: 'text-center' },
        { key: 'middleware_status', label: 'Middleware', class: 'text-center' },
        { key: 'createdAt', label: 'Fecha', sortable: true, class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      detailFields: [
        { key: 'key', label: 'Campo' },
        { key: 'value', label: 'Valor' }
      ],
      leads: [],
      selectedLead: null,
      showModal: false,
      errors: []
    };
  },
  created() {
    if(localStorage.getItem('role')=="Administrador" || localStorage.getItem('role')=="Supervisor" || localStorage.getItem('role')=="Gagsa" ){
      this.search()
    }else{
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    search() {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get('/motorwow?campaign_tag=Motorwow')
      .then(response => {
        this.leads = response.data.data || []
      })
      .catch(e => {
        this.errors.push(e)
        if(e.response && e.response.status === 401) {
          this.$router.push({ name: 'Login' })
        }
      })
    },
    details(lead) {
      this.selectedLead = this.objectToRows(lead)
      this.showModal = true
    },
    objectToRows(obj) {
      var fields = [
        'first_name', 'last_name', 'email', 'fone1_w2l', 'tipo_documento', 'rut_w2l',
        'brand_w2l', 'marca2', 'model_w2l', 'version_w2l', 'sap_w2l', 'price_w2l',
        'department', 'store', 'local_w2l', 'campaign_tag', 'url1_w2l',
        'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'turno',
        'clause', 'terms',
        'original_source', 'interaction_detail',
        'salesforce_status', 'salesforce_sent_at', 'salesforce_error',
        'middleware_status', 'middleware_response', 'middleware_sent_at',
        'createdAt', 'updatedAt'
      ]
      var labels = {
        first_name: 'Nombre',
        last_name: 'Apellidos',
        email: 'Email',
        fone1_w2l: 'Teléfono',
        tipo_documento: 'Tipo Doc.',
        rut_w2l: 'N° Documento',
        brand_w2l: 'Marca',
        marca2: 'Marca (copia)',
        model_w2l: 'Modelo',
        version_w2l: 'Versión',
        sap_w2l: 'Código SAP',
        price_w2l: 'Precio',
        department: 'Departamento',
        store: 'Tienda',
        local_w2l: 'Local',
        campaign_tag: 'Tag Campaña',
        url1_w2l: 'URL Origen',
        utm_source: 'UTM Source',
        utm_medium: 'UTM Medium',
        utm_campaign: 'UTM Campaign',
        utm_content: 'UTM Content',
        turno: 'Turno',
        clause: 'Cláusula',
        terms: 'TyC',
        original_source: 'Original Source (CES)',
        interaction_detail: 'Interaction Detail (CES)',
        salesforce_status: 'Estado Salesforce',
        salesforce_sent_at: 'Envío Salesforce',
        salesforce_error: 'Error Salesforce',
        middleware_status: 'Estado Middleware',
        middleware_response: 'Respuesta Middleware',
        middleware_sent_at: 'Envío Middleware',
        createdAt: 'Creado',
        updatedAt: 'Actualizado'
      }
      return fields.map(function(f) {
        var val
        if (f === 'original_source') {
          val = 'MW'
        } else if (f === 'interaction_detail') {
          val = obj.model_w2l || obj.version_w2l || obj.model || '-'
        } else {
          val = obj[f] !== undefined && obj[f] !== null ? String(obj[f]) : '-'
        }
        return {
          key: labels[f] || f,
          value: val
        }
      })
    },
    descargar_csv() {
      var excel = this.leads.map(function(l) {
        return {
            first_name: l.first_name || l.names || '',
            last_name: l.last_name || '',
            email: l.email || '',
            fone1_w2l: l.fone1_w2l || l.phone || '',
            tipo_documento: l.tipo_documento || '',
            rut_w2l: l.rut_w2l || '',
            brand_w2l: l.brand_w2l || l.brand || '',
            model_w2l: l.model_w2l || l.model || '',
            version_w2l: l.version_w2l || '',
            sap_w2l: l.sap_w2l || '',
            store: l.store || '',
            department: l.department || '',
            campaign_tag: l.campaign_tag || '',
            utm_source: l.utm_source || '',
            utm_medium: l.utm_medium || '',
            utm_campaign: l.utm_campaign || '',
            utm_content: l.utm_content || '',
            turno: l.turno || '',
            salesforce_status: l.salesforce_status || '',
            middleware_status: l.middleware_status || '',
            middleware_response: l.middleware_response || '',
            url1_w2l: l.url1_w2l || '',
            createdAt: l.createdAt || ''
          }
      })
      exportCSVFile(headersCSV, excel, 'motorwow-leads-' + new Date().toISOString().slice(0,10))
    },
    descargar_tiktok_catalog() {
      // Abre el endpoint que genera el CSV del catálogo TikTok
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      const vm = this
      axios.get('/motorwow/tiktok-catalog', { responseType: 'blob' })
        .then(function(response) {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
          const filename = 'motorwow-tiktok-catalog-' + new Date().toISOString().slice(0,10) + '.csv'
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename)
          } else {
            const link = document.createElement('a')
            const url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', filename)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch(function(e) {
          vm.errors.push(e)
          if (e.response && e.response.status === 401) {
            vm.$router.push({ name: 'Login' })
          }
        })
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      var d = new Date(dateStr)
      return d.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LandingMotorwowLeads.vue